/**
 * Micro Degree Course API
 * @author sohyun.ahn@emcast.com
 */
import httpService from "@/api/httpService";

const microCourseApi = {
  /**
   * 목록 필터 기능
   */
  callFilterList(params) {
    return httpService.get(`/micro/learn/online/filter`, params);
  },

  /**
   * 러닝패스 상세 화면
   */
  courseDetail(degreeId) {
    return httpService.get(`/micro/learn/online/${degreeId}`);
  },

  /**
   * 러닝패스 상세 화면 리뷰 평균 및 리뷰 수
   */
  courseReview(degreeId) {
    return httpService.get(`/micro/learn/online/${degreeId}/review/summary`);
  },

  /**
   * 러닝패스 상세 화면 리뷰
   */
  courseReviewTotal(params) {
    return httpService.get(
      `/micro/learn/online/${params.degreeId}/review`,
      params
    );
  },

  /**
   * 러닝패스 총 러닝타임
   */
  courseLearningTime(degreeId) {
    return httpService.get(`/micro/learn/online/${degreeId}/mission`);
  },

  /**
   * 러닝패스 역량
   */
  courseSkillSet(degreeId) {
    return httpService.get(`/micro/learn/online/${degreeId}/skillSet`);
  },

  /**
   * 러닝패스 수료기관
   */
  courseCertificate(degreeId) {
    return httpService.get(`/micro/learn/online/${degreeId}/certificates`);
  },

  /**
   * 차수 분류 (Degree Category)
   */
  degreeCategory() {
    return httpService.get(`/codes/code/MICRO_DEGREE_CATEGORY/tree`);
  },

  /**
   * 과목 (Subject)
   */
  getSubject() {
    return httpService.get(`/micro/learn/subject/combo`);
  },

  /**
   * 난이도 (Course Level)
   */
  getCourseLevel() {
    return httpService.get(`/codes/code/MICRO_COURSE_LEVEL`);
  },

  /**
   * 역량 (Skill Set)
   */
  skillSet() {
    return httpService.get(`/skillset/standard/combo`);
  },

  /**
   * 수료기관 (Institute)
   */
  getInstitute() {
    return httpService.get(``);
  },

  /**
   * 러닝 타임
   */
  runningTime() {
    return httpService.get(`/codes/code/MICRO_DEGREE_RUNNING_TIME/combo`);
  },

  /**
   * 강의 콘텐츠
   */
  learningContents() {
    return httpService.get(`/codes/code/LESSON_RESOURCE_TYPE/combo`);
  },

  /**
   * 가격
   */
  getPricing() {
    return httpService.get(``);
  },

  /**
   * 강의 언어
   */
  getLectureLang() {
    return httpService.get(`/i18n/language/pack/combo`);
  },

  /**
   * 자막 언어
   */
  getSubtitleLang() {
    return httpService.get(``);
  }
};

export default microCourseApi;
